import { graphql, useStaticQuery } from 'gatsby'
import { SubDir } from '../../interface'
import { CatalogueWrapper, ChatButton, ChatDesc, ChatTitle, ChatWrapper, Wrapper } from './atoms'
import { traversalDir } from './collapse-component'
import { Billboard, showContact } from '@foxrenderfarm/common'
import { ChatArrow } from './svg/chat-arrow'
import { useEffect, useState } from 'react'

interface Props {
  firstSubDirs: SubDir | null
  currentSlug: string
  rootSlug: string
  hiddenInMobile?: boolean
}

const query = graphql`
  query {
    chatBg: file(relativePath: { eq: "catalogue/chat-bg.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, breakpoints: [1920], layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`

export const Catalogue = ({ firstSubDirs, currentSlug, rootSlug, hiddenInMobile }: Props) => {
  const { chatBg } = useStaticQuery(query)
  const [showTopBanner, setShowTopBanner] = useState(false)

  const handleStorageChange = () => {
    setShowTopBanner(sessionStorage.getItem('fox_top_hide') !== '1')
  }

  useEffect(() => {
    handleStorageChange()
    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  return (
    <Wrapper $showTopBanner={showTopBanner} $hiddenInMobile={hiddenInMobile}>
      <CatalogueWrapper $showTopBanner={showTopBanner}>
        {firstSubDirs?.map((item) => traversalDir({ item, level: 1, currentSlug, rootSlug }))}
        <ChatWrapper>
          <ChatTitle>Need more help?</ChatTitle>
          <ChatDesc>{`Tell us more and we'll help you soon.`}</ChatDesc>
          <ChatButton onClick={showContact}>
            <span>Chat now with support</span>
            <ChatArrow />
          </ChatButton>
          <Billboard image={chatBg.childImageSharp.gatsbyImageData} alt='Chat now with support' />
        </ChatWrapper>
      </CatalogueWrapper>
    </Wrapper>
  )
}
